export default {
  mutations: {
    SET_PAYOUT_METHODS_LIST: 'SET_PAYOUT_METHODS_LIST',
  },
  getters: {
    GET_PAYOUT_METHODS_LIST: 'GET_PAYOUT_METHODS_LIST',
  },
  actions: {
    PAYOUT_METHODS_LIST: 'PAYOUT_METHODS_LIST',
  },
};
